import React from "react";

/**
 * Card for an email-to-book offering (in-home session, bundle, group,
 * workshop). `meta` is the "75 min • $195" line, or several price lines.
 */
export default function OfferingCard({ id, title, meta, lead, children, cta }) {
  const headingId = `${id}-title`;
  const metaLines = Array.isArray(meta) ? meta : meta ? [meta] : [];
  return (
    <article className="card offering-card" id={id} aria-labelledby={headingId}>
      <h3 id={headingId}>{title}</h3>
      {metaLines.map((line) => (
        <p key={line} className="offering-meta">{line}</p>
      ))}
      {lead ? <p className="offering-lead">{lead}</p> : null}
      <div className="offering-body">{children}</div>
      {cta ? <div className="offering-cta">{cta}</div> : null}
    </article>
  );
}
